import Cookies from 'js-cookie'

import { isEuVersion } from 'common/constants/env'

const isProduction = process.env.NODE_ENV === 'production'

export const getCookie = name => Cookies.get(name)

export const setCookie = (name, value) => {
    const domain = isProduction ? `.interacty.${isEuVersion ? 'eu' : 'me'}` : 'localhost'

    Cookies.set(name, value, { expires: 365, domain })
}

export const deleteCookie = name => Cookies.remove(name)
